<template>
    <b-overlay :show="isLoading">
        <b-card class="m-4">
            <ValidationObserver ref="observer" v-slot="{ passes }">
                <b-form @submit.prevent="passes(saveCustomer)" id="customer-form">
                    <h3><font-awesome-icon icon="user-circle"></font-awesome-icon> Datos generales</h3>
                    <b-row class="mb-2">
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="Razón social" invalid-feedback="Ingresa la razón social">
                                    <b-form-input v-model="customer.legalName" autocomplete="false" placeholder="Razón social"
                                                  :state="errors[0] ? false : null"></b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="RFC" invalid-feedback="Ingresa el RFC">
                                <b-form-input v-model="customer.taxId" autocomplete="false" placeholder="RFC"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="Correo" invalid-feedback="Ingresa el correo">
                                <b-form-input v-model="customer.email" autocomplete="false" placeholder="Correo"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="Teléfono 1">
                                <b-form-input v-model="customer.phone1" autocomplete="false" placeholder="Teléfono 1"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6" lg="4" class="text-left">
                            <b-form-group label="Teléfono 2">
                                <b-form-input v-model="customer.phone2" autocomplete="false" placeholder="Teléfono 2"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <template v-if="customer.address.id > 0 || showAddress">
                        <h3 class="mt-5"><font-awesome-icon icon="address-book"></font-awesome-icon> Dirección fiscal</h3>
                        <b-row class="mb-2">
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="Calle" invalid-feedback="Ingresa la calle">
                                        <b-form-input v-model="customer.address.street" autocomplete="false" placeholder="Calle"
                                                      :state="errors[0] ? false : null"></b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="Número exterior" invalid-feedback="Ingresa el número exterior">
                                        <b-form-input v-model="customer.address.extNumber" autocomplete="false"
                                                      placeholder="Número exterior" :state="errors[0] ? false : null"></b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <b-form-group label="Número interior">
                                    <b-form-input v-model="customer.address.intNumber" autocomplete="false" placeholder="Número interior"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <b-form-group label="Colonia">
                                    <b-form-input v-model="customer.address.neighborhood" autocomplete="false" placeholder="Colonia"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <b-form-group label="Municipio">
                                    <b-form-input v-model="customer.address.borough" autocomplete="false" placeholder="Municipio"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <b-form-group label="Ciudad">
                                    <b-form-input v-model="customer.address.city" autocomplete="false" placeholder="Ciudad"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="Estado" invalid-feedback="Ingresa el estado">
                                        <b-form-input v-model="customer.address.state" autocomplete="false" placeholder="Estado"
                                                      :state="errors[0] ? false : null"></b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="País" invalid-feedback="Ingresa el país">
                                        <b-form-input v-model="customer.address.country" autocomplete="false"
                                                      placeholder="País" :state="errors[0] ? false : null"></b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="6" lg="4" class="text-left">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <b-form-group label="Código postal" invalid-feedback="Ingresa el código postal">
                                        <b-form-input v-model="customer.address.zipCode" autocomplete="false"
                                                      placeholder="Código postal" :state="errors[0] ? false : null"></b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row>
                        <b-col class="text-right">
                            <b-button form="customer-form" variant="primary" class="mr-2" @click="showAddress = !showAddress"
                                      v-if="$route.name === 'CustomerNew' || customer.address.id === 0">
                                <font-awesome-icon icon="address-book"></font-awesome-icon>
                                <template v-if="showAddress"> Remover</template><template v-else> Agregar</template> dirección
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
            <template v-slot:footer>
                <div class="text-right">
                    <b-button variant="outline-secondary" :to="{ name: 'Customer' }"
                              class="mr-2">
                        <font-awesome-icon icon="angle-left"></font-awesome-icon> Regresar
                    </b-button>
                    <b-button type="submit" form="customer-form" variant="primary"><font-awesome-icon icon="save"></font-awesome-icon> Guardar</b-button>
                </div>
            </template>
        </b-card>
    </b-overlay>
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { customerUrl } from '@routes';
import * as constants from '@constants';

extend('required', {
    ...required,
    message: 'Campo requerido'
});

export default {
    props: {
        application: String
    },
    data() {
        return {
            customer: {
                id: 0,
                legalName: '',
                taxId: '',
                email: '',
                phone1: '',
                phone2: '',
                address: {
                    id: 0,
                    street: '',
                    intNumber: '',
                    extNumber: '',
                    neighborhood: '',
                    borough: '',
                    city: '',
                    state: '',
                    country: '',
                    zipCode: '',
                    alias: ''
                }
            },
            showAddress: false,
            isLoading: false
        }
    },
    created() {
        let action = 'Nuevo';

        if (this.$route.name === 'CustomerEdit') {
            this.loadData();

            action = 'Modificar';
        }

        this.$emit('update-breadcrumb-items', [
            {
                text: 'Clientes',
                to: { name: 'Customer' }
            },
            {
                text: action,
                active: true
            }
        ]);
    },
    methods: {
        loadData() {
            this.isLoading = true;

            this.axios.get(customerUrl(), {
                params: {
                    customerId: this.$route.params.id
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    let customer = response.data.customer;

                    this.customer.id = customer.id;
                    this.customer.legalName = customer.legalName;
                    this.customer.taxId = customer.taxId;
                    this.customer.email = customer.email;
                    this.customer.phone1 = customer.phone1;
                    this.customer.phone2 = customer.phone2;

                    if ('address' in customer) {
                        this.customer.address.id = customer.address.id;
                        this.customer.address.street = customer.address.street;
                        this.customer.address.intNumber = customer.address.intNumber;
                        this.customer.address.extNumber = customer.address.extNumber;
                        this.customer.address.neighborhood = customer.address.neighborhood;
                        this.customer.address.borough = customer.address.borough;
                        this.customer.address.city = customer.address.city;
                        this.customer.address.state = customer.address.state;
                        this.customer.address.country = customer.address.country;
                        this.customer.address.zipCode = customer.address.zipCode;
                        this.customer.address.alias = customer.address.alias;
                    }
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        saveCustomer() {
            this.$swal({
                title: '¿Guardar los cambios?',
                icon: 'question'
            }).then(result => {
                if (result.value) {
                    let data = {
                        customer: {
                            id: this.customer.id,
                            legalName: this.customer.legalName,
                            taxId: this.customer.taxId,
                            email: this.customer.email,
                            phone1: this.customer.phone1,
                            phone2: this.customer.phone2
                        }
                    };

                    if (this.showAddress || this.customer.address.id > 0) {
                        data.customer.address = this.customer.address;
                    }

                    const method =  this.customer.id === 0 ? 'post' : 'put';

                    this.axios[method](customerUrl(), data).then(response => {
                        if (response.data.code === constants.CODE_OK) {
                            this.$root.$bvToast.toast(response.data.message, {
                                title: 'Clientes',
                                variant: 'success'
                            });

                            this.$router.push({ name: 'CustomerShow', params: { id: response.data.customerId }});
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: 'Clientes',
                                variant: 'danger'
                            });
                        }
                    }).catch(error => {
                        console.error(error);

                        this.$bvToast.toast('Ocurrió un error al guardar los cambios.', {
                            title: 'Clientes',
                            variant: 'danger'
                        });
                    });
                }
            });
        }
    }
}
</script>

<style scoped>
    label {
        font-weight: 700;
    }
</style>